import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { serviceDescriptions, cancerServices } from '../../data/homeData';
import { Button } from '../ui/button';

export const DoctorSection = () => (
  <section className="py-16 md:py-24 bg-slate-50" data-testid="specialized-doctor-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-12 text-center uppercase tracking-wide">
        Our Specialized Doctor
      </h2>
      <div className="grid lg:grid-cols-2 gap-0 items-stretch max-w-5xl mx-auto rounded-xl overflow-hidden shadow-lg">
        <div className="bg-gray-100 p-8 md:p-12 flex flex-col justify-center text-center">
          <h3 className="font-heading text-3xl font-bold text-primary mb-1">Boris Havkin</h3>
          <p className="text-slate-400 text-lg mb-6">MD</p>
          <p className="text-slate-600 leading-relaxed mb-8">
            Dr. Boris Havkin is a Melbourne, Florida based urologist. He received his medical degree from State University of New York Downstate Medical Center College of Medicine. As a Urologist, Dr. Havkin specializes in treatment of disorders of male and female urinary tract and male reproductive organs. Urologic organs include the kidneys, adrenal glands, bladder, ureters, urethra, testes, epididymis, prostate. He has helped people with bladder or prostate cancer, kidney stones, urinary tract infections, and other genitourinary disorders.
          </p>
          <div>
            <Link to="/about" className="inline-flex items-center gap-2 bg-black text-white font-semibold px-8 py-3 rounded hover:bg-gray-800 transition-colors" data-testid="learn-more-doctor">
              Learn More
            </Link>
          </div>
        </div>
        <div className="overflow-hidden">
          <img
            src="https://customer-assets.emergentagent.com/job_672d1315-e63e-45a4-b5f9-5a02f895fa2f/artifacts/cahm80lh_Dr.Boris%20Havkin%2C%20MD_b%26w.jpg"
            alt="Dr. Boris Havkin, MD - Board-Certified Urologist"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  </section>
);

export const ServicesSection = () => (
  <section className="py-16 md:py-24 bg-white" data-testid="services-description-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-12 text-center uppercase tracking-wide">
        Our Services
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {serviceDescriptions.map((service, index) => (
          <Link
            to={service.path}
            key={index}
            className="group bg-slate-50 rounded-xl p-6 border border-slate-100 hover:border-black/20 hover:shadow-lg transition-all"
            data-testid={`service-desc-${index}`}
          >
            <h3 className="font-heading text-base font-bold text-primary mb-4 uppercase">{service.title}</h3>
            <ul className="space-y-2 mb-4">
              {service.items.map((item, i) => (
                <li key={i} className="text-slate-600 text-sm leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 bg-black rounded-full mr-2 mt-1.5 flex-shrink-0"></span>
                  {item}
                </li>
              ))}
            </ul>
            <span className="inline-flex items-center text-black font-medium text-sm">
              Learn More
              <ArrowRight className="h-4 w-4 ml-1 group-hover:translate-x-1 transition-transform" />
            </span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export const CancerSection = () => (
  <section className="py-16 md:py-24 bg-slate-50" data-testid="cancer-services-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-12 text-center uppercase tracking-wide">
        Urologic Cancer Care
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {cancerServices.map((service, index) => (
          <div key={index} className="bg-white rounded-xl p-6 border border-slate-100" data-testid={`cancer-service-${index}`}>
            <h3 className="font-heading text-base font-bold text-primary mb-4 uppercase">{service.title}</h3>
            <ul className="space-y-2">
              {service.items.map((item, i) => (
                <li key={i} className="text-slate-600 text-sm leading-relaxed flex items-start">
                  <span className="w-1.5 h-1.5 bg-black rounded-full mr-2 mt-1.5 flex-shrink-0"></span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="text-center mt-10">
        <Button asChild variant="outline" className="rounded-full px-8" data-testid="view-all-services-btn">
          <Link to="/mens-health">
            View All Services
            <ArrowRight className="h-4 w-4 ml-2" />
          </Link>
        </Button>
      </div>
    </div>
  </section>
);
